import React from "react";
import FlipIcon from "../assets/icons/flip-icon.svg";
import BuyTicketIcon from "../assets/icons/buy-ticket-icon.svg"
import { useTranslation } from "react-i18next";
import VideoItem from "./VideoItem";
import Wallet from "../assets/icons/video-wallet.svg";
import { metrikaGoal } from "../analytics/metrika";

function CarouselItem({ func, isFlipped, handleBuyJackpotTicket, card }: any) {
    const { t } = useTranslation();

    return (
        <div className="container">
            <div
                className={`flip-card ${isFlipped ? "flipped" : ""
                    }`}
            >
                <div className="flip-card-inner">
                    <div
                        className="flip-card-front"
                        style={{ backgroundImage: `url(${card.bgFront})` }}
                        onClick={() => metrikaGoal('banner_main_click')}
                    >
                        <img
                            src={FlipIcon}
                            alt="icon"
                            className="flip-icon"
                            onClick={(e) => {
                                e.stopPropagation();
                                metrikaGoal('banner_flip');
                                func();
                            }}
                        />
                        <div className="flip-card-front-top-text">
                            <span className="flip-card-front-top-text_first">{t(card.textFront1)}</span>
                            <span className="flip-card-front-top-text_second">{t(card.textFront2)}</span>
                            <span className="flip-card-front-top-text_tired">{t(card.textFront3)}</span>
                        </div>

                        <div className="flip-card-footer">
                            {/*<div className="flip-card-footer_left">*/}
                            {/*    {t(card.textFront)}*/}
                            {/*</div>*/}
                            <div
                                className="flip-button-front"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    metrikaGoal('banner_buy_click');
                                    handleBuyJackpotTicket();
                                }}
                            >
                                <img src={BuyTicketIcon} alt="" className="flip-button-icon" />
                                <span className="flip-button-text">{t('Купить билет')}</span>
                            </div>

                        </div>
                    </div>

                    <div
                        className="flip-card-back"
                        style={{ backgroundImage: `url(${card.bgBack})` }}
                        onClick={() => metrikaGoal('banner_main_click')}
                    >
                        <img
                            src={FlipIcon}
                            alt="icon"
                            className="flip-icon"
                            onClick={(e) => {
                                e.stopPropagation();
                                metrikaGoal('banner_flip');
                                func();
                            }}
                        />
                        <div className="flip-card-back-text">
                            {t(card.textBack)}
                        </div>
                        <div
                            className="flip-button-back"
                            onClick={(e) => {
                                e.stopPropagation();
                                metrikaGoal('banner_buy_click');
                                handleBuyJackpotTicket();
                            }}
                        >
                            <img src={BuyTicketIcon} alt="" className="flip-button-icon" />
                            <span className="flip-button-text">{t('Купить билет')}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CarouselItem
